import { defineProvider } from '@nuxt/image/runtime';
import storyblokImageProvider from '@nuxt/image/runtime/providers/storyblok';
import { mapStoryblokAssetUrlToAkamai } from '../utils/Images';

/**
 * This custom provider for Storblok basically uses the original provider for Storyblok,
 * but replaces the generated URL with our Akamai proxy URL.
 *
 * We do this to keep the traffic within the Akamai network and avoid quota limits on the Storyblok CDN.
 */
export default defineProvider({
  getImage(src, options, ctx) {
    const url = mapStoryblokAssetUrlToAkamai(storyblokImageProvider().getImage(src, options, ctx).url);

    return {
      url,
    };
  },
});
